require("./bootstrap");

// Import modules...
import Vue from "vue";
import { InertiaProgress } from "@inertiajs/progress";
import vuetify from "./vuetify";
import { createInertiaApp } from "@inertiajs/inertia-vue";
import AppLayout from "@/Layouts/AppLayout";
import * as Sentry from "@sentry/vue";
import VueJsonLD from "vue-jsonld";

Sentry.init({
    Vue,
    logErrors: true,
    dsn: process.env.MIX_SENTRY_VUE_DSN,
});

Vue.use(VueJsonLD);

Vue.mixin({
    methods: { route: (url, params) => window.route(url, params, false) },
});

createInertiaApp({
    resolve: (name) => {
        const page = require(`./Pages/${name}`).default;
        page.layout = page.layout || AppLayout;
        return page;
    },
    setup({ el, app, props }) {
        new Vue({
            vuetify,
            render: (h) => h(app, props),
        }).$mount(el);
    },
});

InertiaProgress.init({ color: "#4B5563" });
